export default {
  namespaced: true,
  state: {
    orderMode: "",
    receiveMethod: "",
    amwayPayMode: "",
    otherPayMode: "",
    orderToken: "",
  },
  getters: {
    currentOrderMode(state) {
      return state.orderMode;
    },
    currentReceiveMethod(state) {
      return state.receiveMethod;
    },
    currentAmwayPayMode(state) {
      return state.amwayPayMode;
    },
    currentOtherPayMode(state) {
      return state.otherPayMode;
    },
    orderToken: state => state.orderToken,
  },
  mutations: {
    reset(state) {
      state.orderMode = "";
      state.receiveMethod = "";
      state.amwayPayMode = "";
      state.otherPayMode = "";
      state.orderToken = "";
    },
    changeOrderMode(state, value = "") {
      state.orderMode = value;
    },
    fixReceiveMethod(state, value = "") {
      state.receiveMethod = value;
    },
    changeAmwayPayMode(state, value = "") {
      state.amwayPayMode = value;
    },
    changeOtherPayMode(state, value = "") {
      state.otherPayMode = value;
    },
    updateOrderToken: (state, value = "") => { state.orderToken = value }
  },
}
